module.exports = __webpack_public_path__ + "img/game-started-game.3a5c11b7.png";